import {
  Button,
  FlexColumn,
  FlexRow,
  Input,
  Intent,
  Spacing,
  Switch,
} from '@toilet-paper-games/ui';
import { action } from 'mobx';
import { observer } from 'mobx-react-lite';
import { useHosterAppModel } from '../models/HosterAppModel';
import { SettingsViewModel } from './dialogs/SettingsDialog';
import { FeedbackButton } from '@/common/components/FeedbackButton';

interface SettingsMenuProps {
  viewModel: SettingsViewModel;
}

export const SettingsMenu = observer((props: SettingsMenuProps) => {
  const { viewModel } = props;
  const appStore = useHosterAppModel();
  return (
    <div css={{ width: 400 }}>
      <FlexColumn>
        <FlexColumn gap={5}>
          <span>Manifest URL: </span>
          <Input
            value={viewModel.urlInputValue}
            onChange={action((e) => (viewModel.urlInputValue = e.currentTarget.value))}
          />
          <FlexRow justifyContent="center">
            <Button onClick={viewModel.setUrl}>Set URL</Button>
          </FlexRow>
        </FlexColumn>
        <Spacing mainAxis={30} />

        <FlexColumn gap={5}>
          <span>Dev Mode: </span>
          <Switch
            shadow
            intent={Intent.Warning}
            checked={appStore.devMode}
            onClick={action(() => {
              appStore.devMode = !appStore.devMode;
            })}
          />
        </FlexColumn>
        <Spacing mainAxis={30} />
        <FlexColumn gap={5}>
          <span>Force show end button: </span>
          <Switch
            shadow
            intent={Intent.Primary}
            checked={appStore.forceShowExitButton}
            onClick={action(() => {
              appStore.forceShowExitButton = !appStore.forceShowExitButton;
            })}
          />
        </FlexColumn>
        <Spacing mainAxis={30} />
        <FlexColumn gap={5}>
          <span>Show hidden games: </span>
          <Switch
            shadow
            intent={Intent.Primary}
            checked={appStore.showHiddenGames}
            onClick={action(() => {
              appStore.showHiddenGames = !appStore.showHiddenGames;
            })}
          />
        </FlexColumn>
        <Spacing mainAxis={30} />
        <FeedbackButton />
      </FlexColumn>
    </div>
  );
});
